import React, { useEffect, useState, useCallback, useMemo } from "react";
import Header from "../../sharedScreens/Header";
import SideMenu from "../../sharedScreens/menuItems/SideMenu";
import MuiButton from "../../components/basicComponent/MuiButton";
import MuiSearchSelect from "../../components/basicComponent/MuiSearchSelect";
import { useFormik } from "formik";
import { UtilService } from "../../services/shared/UtilService";
import { AddCommission } from "../../components/composite/AddCommission";
import { categoryType } from "../../constants/constant";
import { exportCommissionToExcel } from "../../constants/helper";

interface CategoryOption {
  label: string;
  value: string;
  id: number;
}

interface CommissionItem {
  commissionType?: string;
  category?: string;
  crsName?: string;
  airlineOfficeId?: string;
  airport?: string;
  cabin?: string;
  flatType?: string;
  fareType?: string;
  per?: string;
  adultChildValue?: string;
  infantValue?: string;
  validFor?: string;
  validUpto?: number;
  conditions?: { conditionType: string; [key: string]: any }[];
  otherOptions?: {
    connectingFlight?: boolean;
    via?: boolean;
    tripType?: string;
  };
  createdAt?: string;
  updatedAt?: string;
}

const AssignCommission: React.FC = () => {
  const [categoriesList, setCategoriesList] = useState<CategoryOption[]>([]);
  const [commissionData, setCommissionData] = useState<CommissionItem[]>([]);
  const [hasSearched, setHasSearched] = useState(false);

  const [viewMode, setViewMode] = useState<"create" | "view" | "default">(
    "create"
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const formik = useFormik({
    initialValues: {
      customerName: "",
      businessType: "",
      category: "",
      type: "",
      basedOn: "",
      airline: "",
      categoryId: "",
    },
    // validationSchema: ViewAssignCommissionSchema,
    enableReinitialize: true,
    onSubmit: () => handleSubmit(),
  });

  // 🔹 Fetch categories
  const getCategoriesList = useCallback(async () => {
    try {
      const res = await UtilService.categoriesList();
      const data =
        res?.data?.map((i: { name: string; id: number }) => ({
          label: i?.name,
          value: i?.name,
          id: i?.id,
        })) || [];
      setCategoriesList(data);
    } catch (error) {
      console.error("Error fetching categories", error);
    }
  }, []);

  // 🔹 Fetch commission info
  const getFlightCommissionInfo = async (params: {}) => {
    try {
      const res = await UtilService.getFlightCommissionInfo(params);
      setCommissionData(res?.data || []);
    } catch (error) {
      console.error("Error fetching commission info", error);
    }
  };

  const handleSubmit = () => {
    if (!formik.values.type) return;
    const params = {
      commission_type: formik.values.type,
      category: formik.values.categoryId,
    };
    setHasSearched(true);
    getFlightCommissionInfo(params);
  };

  // 🔹 Pagination
  const currentData = useMemo(
    () =>
      commissionData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
      ),
    [commissionData, currentPage, itemsPerPage]
  );

  useEffect(() => {
    getCategoriesList();
  }, [getCategoriesList]);

  // 🔹 Views
  const renderCreateAssignCommission = () => (
    <>
      <div className="row mt-4 user-manage-model">
        <div className="col-md-3 mb-3 mb-md-0">
          <MuiSearchSelect
            label="Type"
            value={formik.values.type}
            placeholder="Type"
            options={categoryType}
            onChange={(value) => formik.setFieldValue("type", value)}
          />
        </div>

        <div className="col-md-3">
          <MuiSearchSelect
            label="Category"
            value={formik.values.category}
            placeholder="Category"
            options={categoriesList}
            onChange={(value, id) => {
              formik.setFieldValue("category", value);
              formik.setFieldValue("categoryId", id);
            }}
          />
        </div>

        <div className="col-md-3 d-flex justify-content-center align-items-center gap-3">
          <div>
            <MuiButton
              className="main-btn get-btn"
              variant="contained"
              size="large"
              type="submit"
              label="Get"
              style={{ height: "39px" }}
              onClick={() => formik.handleSubmit()}
            />
          </div>
          <div className="mt-3 mt-md-0">
            <button
              type="button"
              className="btn btn-success"
              style={{ width: "147px", height: "39px" }} // same height as GET button
              onClick={() => exportCommissionToExcel(commissionData)}
            >
              <i className="fas fa-file-excel"></i> Export to Excel
            </button>
          </div>
        </div>
      </div>

      {/* Results Table */}
      {hasSearched && (
        <div className="row">
          <div className="card-body scrollable-x-auto">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Category</th>
                  <th>CRS</th>
                  <th>Airline</th>
                  <th>Airport</th>
                  <th>Cabin</th>
                  <th>Flat Type</th>
                  <th>Fare Type</th>
                  <th>Percentage (%)</th>
                  <th>Adult/Child Value</th>
                  <th>Infant Value</th>
                  <th>Valid For</th>
                  <th>Valid Upto</th>
                  <th>Connecting Flight</th>
                  <th>Via</th>
                  <th>Trip</th>

                  <th>Created Date</th>
                  <th>Updated Date</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? (
                  currentData.map((item, index) => (
                    <>
                      {console.log("item", item)}
                      <tr key={index}>
                        <td>
                          <div className="sort">{item.commissionType}</div>
                        </td>
                        <td>
                          <div className="sort">{item.category}</div>
                        </td>
                        <td>
                          <div className="sort">{item.crsName}</div>
                        </td>
                        <td>
                          <div className="sort">{item.airlineOfficeId}</div>
                        </td>
                        <td>
                          <div className="sort">{item.airport}</div>
                        </td>
                        <td>
                          <div className="sort">{item.cabin}</div>
                        </td>
                        <td>
                          <div className="sort">{item.flatType}</div>
                        </td>
                        <td>
                          <div className="sort">{item.fareType}</div>
                        </td>
                        <td>
                          <div className="sort">{item.per}</div>
                        </td>
                        <td>
                          <div className="sort">{item.adultChildValue}</div>
                        </td>

                        <td>
                          <div className="sort">{item.infantValue}</div>
                        </td>
                        <td>
                          <div className="sort">{item.validFor}</div>
                        </td>
                        <td>
                          <div className="sort">{item.validUpto}</div>
                        </td>
                        <td>
                          <div className="sort">
                            {item.otherOptions?.connectingFlight ? "Yes" : "No"}
                          </div>
                        </td>
                        <td>
                          <div className="sort">
                            {item.otherOptions?.via ? "Yes" : "No"}
                          </div>
                        </td>
                        <td>
                          <div className="sort">
                            {item.otherOptions?.tripType}
                          </div>
                        </td>

                        <td>
                          <div className="sort">
                            {item.createdAt?.slice(0, 10)}
                          </div>
                        </td>
                        <td>
                          <div className="sort">
                            {item.updatedAt?.slice(0, 10)}
                          </div>
                        </td>
                      </tr>
                    </>
                  ))
                ) : (
                  <tr>
                    <td colSpan={16} className="text-center py-4">
                      <h5 className="text-muted fw-bold">
                        No Commission Data Found
                      </h5>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </>
  );

  const renderSetDefault = () => (
    <div className="row mt-4">
      <div className="col-md-4">
        <MuiSearchSelect
          label="Business Type"
          placeholder="Business Type"
          options={[]}
          value={formik.values.businessType}
          onChange={(value) => formik.setFieldValue("businessType", value)}
        />
      </div>
      <div className="col-md-4">
        <MuiSearchSelect
          label="Category"
          placeholder="Category"
          options={[]}
          value={formik.values.category}
          onChange={(value) => formik.setFieldValue("category", value)}
        />
      </div>
      <div className="col-md-2 mt-2">
        <MuiButton
          className="main-btn get-btn"
          variant="contained"
          size="large"
          type="submit"
          label="Get"
        />
      </div>
    </div>
  );

  return (
    <div className="grow">
      <SideMenu />
      <div className="wrapper flex grow flex-col">
        <Header />
        <main className="grow content" id="content" role="content">
          <div className="container-fixed">
            <div className="card-header mb-1 managebookingg d-block d-sm-flex">
              <h3 className="card-title titlecolorr">
                {viewMode === "create" && "Create Assign Commission/Mark Up"}
              </h3>
              <div className="mt-3 mt-sm-0">
                {viewMode !== "create" && (
                  <button
                    className="fliter-btn me-2 mb-2 mt-md-0"
                    onClick={() => setViewMode("create")}
                  >
                    Back
                  </button>
                )}
                <button
                  className="fliter-btn me-2"
                  onClick={() => setViewMode("create")}
                >
                  Create Assign Commission/Mark Up
                </button>
                <button
                  className="fliter-btn me-2 mt-2 mt-md-0"
                  onClick={() => setViewMode("view")}
                >
                  View Assign Commission/Mark Up
                </button>
                <button
                  className="fliter-btn mt-2 mt-md-0 seat-btn-color"
                  onClick={() => setViewMode("default")}
                >
                  Set Default
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <div className="card card-custom">
                  <div className="card-body">
                    {viewMode === "create" && <AddCommission />}
                    {viewMode === "view" && renderCreateAssignCommission()}
                    {viewMode === "default" && renderSetDefault()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AssignCommission;
